import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { FlexRow } from '../misc';

export const TopBar = styled(FlexRow)`
  position: fixed;
  top: 60px;
  right: 0;
  height: 60px;
  width: 100%;
  background-color: ${themeGet('colors.redLight')};
  z-index: 10;
`;

export const ArticleDetailOverlay = styled('div')`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  opacity: ${props => (props.show ? 1 : 0)};
  background: rgba(0, 0, 0, 0.4);
  transition: opacity 0.5s cubic-bezier(0, 0, 0.3, 1);
  will-change: opacity;
  pointer-events: ${props => (props.show ? 'auto' : 'none')};
  z-index: 40;
`;



// WEBPACK FOOTER //
// ./src/components/portals/style.js